<template>

    <div>

        <v-alert :type="atype" dismissible v-model="visibility" transition="scale-transition">

            <span v-html="message"></span>

        </v-alert>

    </div>

</template>

<script>
export default {
    name: 'Alert',
    props: [
        "atype", "message", "visibility"
    ]
}
</script>
